import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojalnacab() {



  const cardData =
  {
    keyword: 'Pune to Jalna cab',
    heading: 'Sai Trupti Cabs: Pune to Jalna cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Jalna cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Jalna. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Jalna convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Jalna with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Jalna Fort",
    "description": "Jalna Fort is a historic landmark that reflects the city’s strategic importance during the Mughal and Deccan Sultanate periods. Built in the 16th century, the fort is known for its massive stone walls, strong bastions, and ancient gateways. Though partially in ruins today, it still echoes stories of battles, administration, and royal presence. Walking through the fort offers a glimpse into Jalna’s military and political past. It stands as a silent guardian of the city’s rich historical legacy."
  },
  {
    "title": "Matsyodari Devi Temple",
    "description": "Matsyodari Devi Temple is the most revered spiritual site in Jalna, dedicated to Goddess Durga. Situated in a serene setting, the temple attracts thousands of devotees, especially during Navratri. The divine atmosphere, rhythmic chants, and vibrant festivals create a powerful spiritual experience. Locals consider the goddess as the city’s guardian deity. The temple represents faith, devotion, and Jalna’s deep-rooted cultural traditions."
  },
  {
    "title": "Kundlikeshwar Temple",
    "description": "Kundlikeshwar Temple is an ancient and sacred shrine dedicated to Lord Shiva, located near a perennial water source. Known for its peaceful surroundings and spiritual aura, the temple is especially significant during Mahashivratri. Devotees visit to seek blessings and inner calm. The simple architecture and natural setting enhance its meditative charm. It is a quiet retreat for spiritual seekers in and around Jalna."
  },
  {
    "title": "Jamb Samarth",
    "description": "Jamb Samarth is a holy village near Jalna, associated with the revered saint Samarth Ramdas, the spiritual guru of Chhatrapati Shivaji Maharaj. The place is home to an ancient Ram temple and a sacred pond believed to have spiritual significance. Surrounded by gentle hills and calm landscapes, it offers a peaceful environment for devotees. Pilgrims visit to connect with Maharashtra’s Bhakti tradition. Jamb Samarth beautifully blends spirituality, history, and devotion."
  },
  {
    "title": "Anandi Swami Temple",
    "description": "Anandi Swami Temple is a respected religious site in Jalna, known for its calm ambiance and spiritual significance. Dedicated to Anandi Swami Maharaj, the temple attracts followers seeking peace and guidance. Regular bhajans and religious gatherings create a devotional atmosphere. The simplicity of the temple adds to its spiritual charm. It remains an important center of faith for the local community."
  },
  {
    "title": "Paithan (Nearby Attraction)",
    "description": "Paithan, located near Jalna, is an ancient town on the banks of the Godavari River and a major cultural attraction. Famous for its exquisite Paithani sarees, the town has roots dating back to the Satavahana dynasty. The Jayakwadi Dam nearby adds scenic beauty to the region. Temples, ghats, and handloom traditions make Paithan culturally rich. It’s a must-visit destination for history and art lovers."
  },
  {
    "title": "Jayakwadi Dam",
    "description": "Jayakwadi Dam, one of Maharashtra’s largest dams, is a major attraction near Jalna. Built across the Godavari River, it plays a vital role in irrigation and water supply for the region. The vast reservoir, bird sightings, and open landscapes make it a scenic spot, especially during monsoon and winter. Migratory birds add to its ecological importance. The dam showcases the harmony between engineering and nature."
  },
  {
    "title": "Agricultural Market (Jalna Mandi)",
    "description": "Jalna is known as one of Maharashtra’s major agricultural trade centers, especially famous for pulses, seeds, and grains. The bustling market yards reflect the city’s economic strength and rural connection. Traders from across the state visit for high-quality produce. Observing the market offers insight into the backbone of Jalna’s economy. It represents the hardworking spirit of farmers and traders alike."
  },
  {
    "title": "Local Jain Temples",
    "description": "Jalna is home to several beautiful Jain temples that reflect the city’s religious diversity. These temples are known for their clean marble structures, intricate carvings, and peaceful ambiance. They serve as important centers for prayer, meditation, and community gatherings. The calm environment invites quiet reflection. Together, they highlight Jalna’s tradition of harmony and spiritual coexistence."
  },
  {
    "title": "Nearby Nature Trails and Villages",
    "description": "The rural surroundings of Jalna offer scenic village landscapes, farmlands, and quiet nature trails. These areas provide a refreshing escape from urban life and a chance to experience authentic Marathwada culture. Sunrise and sunset views over open fields are especially captivating. The simplicity of village life adds warmth and charm. Exploring these surroundings reveals the soul of Jalna beyond the city limits."
  }
],



 "services": [
    {
      "name": "Pune to Jalna Cab",
      "description": "Reliable cab service from Pune to Jalna offering AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup and drop points, real-time tracking, and transparent fares. Ideal for families, solo travelers, and business commuters."
    },
    {
      "name": "Jalna to Pune Cab",
      "description": "Comfortable cab service from Jalna to Pune with well-maintained vehicles, experienced drivers, AC/non-AC options, luggage support, and timely pickups for smooth long-distance travel."
    },
    {
      "name": "Pune to Jalna Taxi",
      "description": "Safe and convenient taxi service from Pune to Jalna providing point-to-point travel, professional chauffeurs, AC comfort, luggage assistance, and transparent pricing."
    },
    {
      "name": "Pune to Jalna Cab Service",
      "description": "Dedicated cab service from Pune to Jalna with multiple vehicle options, flexible schedules, experienced drivers, and reliable long-distance travel comfort."
    },
    {
      "name": "Pune to Jalna Outstation Cab",
      "description": "Outstation cab service from Pune to Jalna offering comfortable AC/non-AC cars, professional drivers, luggage assistance, and cost-effective fares for long-distance journeys."
    },
    {
      "name": "Pune to Jalna Innova Cab",
      "description": "Spacious Innova cab service from Pune to Jalna featuring AC comfort, ample luggage space, and professional drivers. Ideal for family trips and group travel."
    },
    {
      "name": "Pune to Jalna Innova Crysta Cab",
      "description": "Premium Innova Crysta cab service from Pune to Jalna offering luxury seating, superior comfort, AC travel, and experienced chauffeurs."
    },
    {
      "name": "Pune to Jalna Ertiga Cab",
      "description": "Ertiga cab service from Pune to Jalna suitable for small groups, offering AC/non-AC options, comfortable seating, and affordable pricing."
    },
    {
      "name": "Pune to Jalna Sedan Cab",
      "description": "Sedan cab service from Pune to Jalna providing smooth rides, professional drivers, AC/non-AC options, and economical fares for solo travelers and couples."
    },
    {
      "name": "Pune to Jalna SUV Taxi",
      "description": "SUV taxi service from Pune to Jalna offering extra space, AC comfort, powerful performance, and professional drivers for long-distance travel."
    },
    {
      "name": "Pune to Jalna AC Cab",
      "description": "AC cab service from Pune to Jalna ensuring cool, comfortable, and safe travel with experienced drivers and transparent fares."
    },
    {
      "name": "Pune Airport to Jalna Cab",
      "description": "Hassle-free cab service from Pune Airport to Jalna with timely pickups, flight tracking, AC vehicles, and professional drivers."
    },
    {
      "name": "Hinjewadi to Jalna Taxi",
      "description": "Taxi service from Hinjewadi to Jalna offering reliable AC/non-AC vehicles, experienced drivers, and flexible pickup points."
    },
    {
      "name": "Wakad to Jalna Cab",
      "description": "Cab service from Wakad to Jalna with comfortable vehicles, professional chauffeurs, luggage assistance, and transparent pricing."
    },
    {
      "name": "Hadapsar to Jalna Taxi",
      "description": "Safe and comfortable taxi service from Hadapsar to Jalna featuring AC/non-AC vehicles, experienced drivers, and easy booking."
    },
    {
      "name": "Pimpri Chinchwad to Jalna Cab",
      "description": "Reliable cab service from Pimpri Chinchwad to Jalna offering door-to-door pickup, comfortable vehicles, and economical fares."
    },
    {
      "name": "Pune to Jalna Business Travel Taxi",
      "description": "Professional business travel taxi from Pune to Jalna with punctual service, comfortable AC vehicles, and experienced chauffeurs."
    },
    {
      "name": "Pune to Jalna Family Trip Cab",
      "description": "Family-friendly cab service from Pune to Jalna with spacious vehicles, safety-focused drivers, and comfortable long-distance travel."
    },
    {
      "name": "Pune to Jalna Night Travel Cab",
      "description": "Safe night travel cab service from Pune to Jalna with experienced drivers, well-maintained vehicles, and reliable support."
    },
    {
      "name": "Pune to Jalna Long Distance Taxi",
      "description": "Long-distance taxi service from Pune to Jalna offering smooth rides, AC comfort, professional drivers, and transparent fares."
    },
    {
      "name": "Pune to Ambad Cab Service",
      "description": "Cab service from Pune to Ambad offering comfortable vehicles, professional drivers, flexible pickup points, and affordable pricing."
    },
    {
      "name": "Pune to Partur Cab",
      "description": "Reliable cab service from Pune to Partur with AC/non-AC options, experienced drivers, and smooth long-distance travel."
    },
    {
      "name": "Pune to Bhokardan Cab Booking",
      "description": "Easy cab booking service from Pune to Bhokardan with comfortable vehicles, professional drivers, and transparent fares."
    },
    {
      "name": "Pune to Jafrabad Cab Booking",
      "description": "Convenient cab booking from Pune to Jafrabad offering reliable vehicles, experienced chauffeurs, and flexible scheduling."
    },
    {
      "name": "Pune to Badnapur Cab",
      "description": "Cab service from Pune to Badnapur providing comfortable rides, AC/non-AC vehicles, and professional drivers."
    },
    {
      "name": "Pune to Ghansavangi Cab",
      "description": "Trusted cab service from Pune to Ghansavangi with well-maintained vehicles, experienced drivers, and affordable long-distance travel."
    }
  ],
  "tableData": [
    ["Pune to Jalna Cab", "Jalna to Pune Cab"],
    ["Pune to Jalna Taxi", "Pune to Jalna Cab Service"],
    ["Pune to Jalna Outstation Cab", "Pune to Jalna Outstation Taxi Service"],
    ["Pune to Jalna Innova Cab", "Pune to Jalna Innova Crysta Cab"],
    ["Pune to Jalna Ertiga Cab", "Pune to Jalna Sedan Cab"],
    ["Pune to Jalna SUV Taxi", "Pune to Jalna AC Cab"],
    ["Pune Airport to Jalna Cab", "Hinjewadi to Jalna Taxi"],
    ["Wakad to Jalna Cab", "Hadapsar to Jalna Taxi"],
    ["Pimpri Chinchwad to Jalna Cab", "Pune to Jalna Business Travel Taxi"],
    ["Pune to Jalna Family Trip Cab", "Pune to Jalna Night Travel Cab"],
    ["Pune to Ambad Cab Service", "Pune to Partur Cab"],
    ["Pune to Bhokardan Cab Booking", "Pune to Jafrabad Cab Booking"],
    ["Pune to Badnapur Cab", "Pune to Ghansavangi Cab"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Jalna Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Jalna — perfect for business trips, family travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Pune to Jalna start from approximately ₹3,500–₹4,800 for sedans, with SUVs and luxury car options available at competitive rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage needs, and comfort preferences for the Pune → Jalna route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced with long-distance routes like Pune to Jalna, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs across Jalna — including hotels, stations, and residential areas."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic inter-city ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, or route planning for your Pune to Jalna cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Jalna cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Jalna cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Pune to Jalna for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to Jalna cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Jalna cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Jalna?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs to suit your travel needs and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Jalna trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Jalna for corporate or personal travel?',
    answer: 'Certainly. Our cab services cater to corporate clients, family trips, and leisure travel between Pune and Jalna.',
  },
  {
    question: 'Is the Pune to Jalna cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Jalna trips for maximum convenience and flexibility.',
  },
  {
    question: 'What are the Pune to Jalna cab fares?',
    answer: 'Our cab fares start from approximately ₹3,500 for sedans and ₹4,800–₹6,500 for SUVs and premium vehicles, depending on travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Jalna cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Jalna cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Jalna cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Jalna cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Jadhav',
    feedback: 'I booked a Pune to Jalna cab with Sai Trupti Cabs. The journey was smooth, and the driver was very experienced.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Shinde',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Jalna trip. Clean car and polite driver.',
    rating: 5,
  },
];













































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jalna Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-jalna-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Jalna cab service with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable long distance outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7860"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-jalna-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};








  return (
    <div>
<Helmet>
  <title>Pune to Jalna Cab Service | One Way Taxi ₹3999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Jalna cab at best price ₹3999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service for long distance travel." 
  />

  <meta 
    name="keywords" 
    content="pune to jalna cab, pune to jalna taxi, pune to jalna cab service, pune to jalna one way cab, pune to jalna taxi fare, pune to jalna innova crysta, pune to jalna ertiga cab, pune to jalna sedan cab, cheap pune to jalna cab, best cab service pune to jalna, pune to jalna drop taxi, pune to jalna round trip cab, outstation cab pune to jalna, pune to jalna online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojalnacab;